import { selectFunctionalDepreciationCommentaryTableDisplay } from '../../../redux/features/selectors/commentarySelectors/selectFunctionalDepreciationCommentary.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { CommentarySubSection } from '../components/CommentarySubsection.tsx';
import { CommentaryTable } from '../components/CommentaryTable.tsx';
import { COMMENTARY_TEXT } from '../consts.ts';

const props = COMMENTARY_TEXT['dep-cost'].subItems['functionalDepreciation'];

export const FunctionalDepreciation = () => {
  const data = useAppSelector((state) => selectFunctionalDepreciationCommentaryTableDisplay(state));

  return (
    <CommentarySubSection {...props}>
      <CommentaryTable {...data} />
    </CommentarySubSection>
  );
};
